export let itMessages={
  "privacy_policy_and_terms_of_use":"Privacy Policy and Terms of Use ",
  "privacy_confirm_text":"We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree":"Disagree",
  "privacy_confirm_accept":"Accept",

  "title":"EasyView Personal",
  "title1":"EasyView Pro",
  "user":"Email",
  "password":"Password",
  "remember":"Ricordami",
  "forget":"Password dimenticata?",
  "sign in":"Login",
  "login":"Login",
  "sign up now":"Registrati ora",
  "apply":"Registrati ora",
  "contact us":"Contattaci",
  "Privacy Policy":"Informativa sulla privacy",
  "Terms of Use":"Termini di utilizzo",
  "copyright":"Copyright © 2021 Medtrum Technologies Inc. Tutti i diritti riservati.",

  "chooseLang":"Seleziona il tuo paese o la lingua",
  "asia":"Asia",
  "europe":"Europa",

  "applyHcp":"Registra una nuova utenza HCP",
  "sign up":"Registrati",
  "Patient":"Paziente",
  "Caregiver":"Assistente domiciliare",
  "Email":"Email",
  "Mobile":"Cellulare",
  "Enter email":"Inserisci l'indirizzo email",
  "Enter mobile":"Inserisci il numero di cellulare",
  "Verification":"Codice di verifica",
  "Invitation":"Invitation code",
  "full name":"Inserisci il tuo nome completo",
  "Enter pass":"Inserisci la password",
  "org":"Organizzazione",
  "Register":"Registrati",
  "send":"Invia",
  "agree":"Dichiaro di aver letto e accettato l' ",
  "privacy":" 'Informativa sulla privacy' ",
  "and" :"ed i ",
  "use":"'Termini di utilizzo'",
  "errtip1-1":"Devi inserire un indirizzo email valido,",
  "errtip1-2":" il quale diventerà il tuo nome utente Medtrum.",
  "errtip2":"Please enter a valid mobile number.",
  "errtip3":"Codice di verifica non corretto",
  "errtip4":"Incorrect invitation code.",
  "errtip5":"Nome utente non corretto",
  "errtip6":"Your password must have 8 or more characters.",
  "errtip7":"Si prega di inserire la propria organizzazione.",

  "errp1":"La password deve contenere almeno 3 tipi dei seguenti caratteri:",
  "errp2":"Lettere maiuscole, lettere minuscole, numeri e caratteri speciali.",
  "errp3":"La password deve essere lunga tra i 6 e i 20 caratteri.",
  "errp4":" La password deve essere diversa dal nome utente.",
  "errp5":"Una password con 3 numeri consecutivi non è valida (es. 123, 321).",
  "errp6":"Una password con 3 lettere consecutive non è valida (es. abc, cba).",
  "errp7":"La password non può contenere spazi.",


  "Find account":"Recupera la tua password.",
  "Enter username":"Inserisci il tuo cognome.",
  "Next":"Successivo",
  "Cancel":"Annulla",
  "Back":"Indietro",
  "Enter veri":"Inserisci Codice di verifica",
  "Verify notice":"Si prega di cercare il codice di verifica inviato in e-mail.",
  "Create new":"Crea una nuova password",
  "Create new notice":"Si prega di creare una nuova password che deve avere 6 o più caratteri.",
  "New pass" :"Nuova password",
  "Completed":"Completato",
  "Created":"Nuova password creata.",
  "Login Now":"Registrati ora",

  "Delete":"Elimina",
  "New Patient":"New Patient",
  "Add Patient":"Aggiungi paziente",
  "Filter":"Filtra",
  "Name":"Nome",
  "Gender":"Sesso",
  "Age":"Età",
  "Type":"Tipo",
  "Duration":"Durata",
  "Connections":"Creatore di account",
  "UploadTime":"Tempo di caricamento",
  "Year":"anni",
  "Years":"anni",
  "Month":"mese",
  "Month2":"Mese",
  "Months":"mese",
  "Invite":"Invita",
  "Invited":"Invitato",
  "All":"Tutti",
  "Female":"Femmina",
  "Male":"Maschio",
  "Not Set":"Imprecisato",
  "Type 1":"Tipo 1",
  "Type 2":"Tipo 2",
  "Gestational":"Gestazionale",
  "Prediabetes":"Prediabete",
  "LADA":"Tipo 1.5 LADA",
  "Apply":"Applica",
  "disUn":"Tipo di diabete non corretto",
  "ageUn":"Età non specificata",
  "genUn":"Sesso non specificato",
  "addP":"Aggiungi paziente",
  "newP":"Nuovo paziente",
  "findP":"Trova paziente",

  "GDRNF":"Imprecisato",
  "GDRF":"Femmina",
  "GDRM":"Maschio",
  "女":"Maschio",

  "DBTNF":"imprecisato",
  "DBT1":"Tipo 1",
  "DBT2":"Tipo 2",
  "DBTLADA":"Tipo 1.5 LADA",
  "DBTPRE":"Prediabete",
  "DBTGEST":"Gestazionale",
  "前期":"beFore",
  "beFore":"beFore",
  "MODY":"Mody",

  "No selection":"Imprecisato",
  "unspecif":"Imprecisato",
  "register":"Paziente",
  "hcp":"Medico",

  "BG":"GS",
  "CARB":"Carboidrati",
  "INS":"Iniezione",
  "EXR":"Esercizio",
  "OTR":"Altro",
  "HBA1C":"HbA1c",
  "DOSE":"DOSE",
  "URINEK":"Chetone nelle urine",
  "HEL":"HEL",
  "OTR1":"Altro",
  "Loading":"Caricamento in corso",

  "home":"Casa",
  "pID":"ID paziente",
  "fullName":"Nome e cognome",
  "gender":"Sesso",
  "height":"Altezza",
  "weight":"Peso",
  "cm":"cm",
  "kg":"kg",
  "birthday":"Data di nascita",
  "disType":"Tipo di diabete",
  "disDate":"Data della diagnosi",
  "Address":"Indirizzo",
  "Postcode":"CAP",
  "Inpatient":"Ricoverato",
  "Yes":"Sì",
  "No":"No",
  "Pno":"N. paziente",
  "Bno":"N. letto",
  "create":"Crea",
  "Telephone":"Telefono",

  "enterU":"Inserisci il nome utente (email)",
  "search":"Ricerca",
  "noU":"È richiesto il nome utente.",
  "searchR":"Search results",
  "uername":"Nome utente",
  "alias":"Alias",
  "remove":"Rimuovi",
  "viewG":"Visualizza grafici",
  "sendR":"Invia richiesta",
  "rSent":"La tua richiesta è stata inviata.",
  "cancelR":"Annulla richiesta",

  "VcodeTip1":"Non l'hai ricevuto? Si prega di attendere un minuto e ",
  "VcodeTip2":"Riprova",
  "VcodeTip3":"Abbiamo appena inviato un codice di verifica a ",
  "Entercode":"Inserisci il codice",
  "Getcode":"Ottieni il codice",

  "messages":"Messaggi",
  "profile":"Profilo",
  "sign out":"Log out",
  "changeP":"Cambia la password",
  "connection":"Elenco contatti",

  "myP":"Il mio profilo",
  "Portrait":"Foto profilo",
  "Profession":"Professione",
  "DPRONF":"Imprecisata",
  "DPROENDOCRIN":"Endocrinologo",
  "DPRODIABTRA":"Educatore per il diabete",
  "DPRONURSE":"Infermiera",
  "DPRODIATIT":"Dietista",
  "DPROOTR":"Altri operatori sanitari",
  "Organization":"Organizzazione",
  "Bio":"Bio",
  "save":"Salva",
  "oldPa":"Vecchia password",
  "newPa":"Nuova password",
  "RePa":"Reinserisci la password",
  "forgetY":"Hai dimenticato la password?",
  "applyM":"Applica",
  "oldErr":"La vecchia password non è corretta.",
  "EntTheSame":"Inserisci nuovamente la nuova password.",
  "EnterOld":"Inserisci la vecchia password.",

  "pList":"Lista dei pazienti",
  "connections":"Elenco contatti",
  "settings":"Impostazioni",
  "monitor":"Monitor",
  "graphs":"Report",
  "events":"Eventi",
  "records":"Record",
  "qPrint":"Stampa veloce",

  "sensorIn":"Informazioni sul sensore",
  "timeOfLaRead":"Ora dell'ultima lettura dal sensore",
  "tranSn":"SN del trasmettitore",
  "status":"Stato",
  "sensorLife":"Durata rimanente del sensore",
  "lastSenorRead":"Ultima lettura dal sensore",
  "TranBattery":"Batteria del trasmettitore",
  "sg":"SG",
  "alert":"Avvisi",
  "target":"Obiettivo",
  "hypo":"Ipo",
  "sensorGlucose":"Glucosio sensore",
  "calib":"Calibrazione",
  "newSen":"Nuovo sensore",
  "warm":"Riscaldamento",
  "InsulinPump":"Microinfusore",
  "timeOfLaPump":"Ora dell'ultimo dato dal microinfusore",
  "pumpSN":"SN base microinfusore",
  "ReserviorLife":"Durata rimanente del serbatoio",
  "InsulinLeft":"Insulina rimanente",
  "basal":"Basale",
  "bolus":"Bolo",
  "totalBasal":"Basale giornaliera totale",
  "lastBolus":"Ultimo bolo",
  "activeInsulin":"Insulina attiva",
  "totalBolus":"Bolo giornaliero totale",
  "tampBasal":"Basale temp",
  "normalBolus":"Bolo normale",
  "extendBolus":"Bolo esteso",
  "manualStop":"Sospensione manuale",
  "autoStop":"Sospensione automatica",
  "auto suspend":"Sospensione automatica",
  "stop":"Somministrazione sospesa",
  "newPatch":"Nuova patch",
  "tempBasal":"Basale temp.",
  "N":"N",
  "E":"E",
  "CN1":"CN",
  "CE":"CE",

  "staticSettings":"Impostazioni report",
  "dataSource":"Origine dei dati",
  "unit":"Unità",
  "glucoseTarget":"Obiettivo glicemico",
  "overall":"Totale",
  "Hypoglycemia":"Ipoglicemia",
  "timePeriod":"Intervallo",
  "postMeal":"Analisi post pasto",
  "Breakfast":"Colazione",
  "Lunch":"Pranzo",
  "Dinner":"Cena",
  "night":"Notte",
  "Before":"Prima",
  "After":"Dopo",
  "Low":"Basso",
  "High":"Alto",
  "From":"Da",
  "To":"A",
  "Hours":"ore",
  "Reset":"Ripristina i valori predefiniti",
  "RealTime":"Tempo reale",
  "uploaded":"Caricato",
  "sensor":"Sensore",
  "pdmSN":"SN PDM",
  "startTime":"Ora di inizio",
  "endTime":"Ora di fine",
  "uploadTime":"Ora di caricamento",
  "pdm":"PDM",
  "Uploaded":"Caricato",
  "Patch Pump":"PDM",
  "overLapp":"Sessioni sovrapposte",

  //"dashboard":"Riepilogo",

  "daily":"Riepilogo giornaliero",
  "date":"Data",
  "print":"Stampa",
  "carbs":"Carboidrati",
  "exercise":"Esercizio",
  "heavy":"Pesante",
  "Medium":"Medio",
  "Light":"Leggero",
  "dailyReport":"Report di riepilogo giornaliero",
  "devices":"Dispositivi",
  "tran":"Trasmettitore",
  "pumpBase":"Base del microinfusore",
  "HbA1c":"HbA1c",
  "statics":"Statistiche",
  "glucose":"Glucosio",
  "item":"Elemento",
  "BG1":"GS",
  "SG1":"SG",
  "avgSD":"Media (mmol/L)±SD",
  "avgSD1":"Media±SD",
  "min":"Min",
  "max":"Max",
  "ofRead":"# di letture",
  "ofHypo":"# di ipo/durata(min)",
  "ofAlert":"# di avvisi",
  "insulin":"Insulina",
  "insulin2":"Insulina",
  "totalDose":"Dose giornaliera totale",
  "foodBolus":"Bolo alimentare ",
  "Food+coor":"Food+corr",
  "calibBolus":"Correzione bolo",
  "durationStop":"Durata della sospensione(min)",
  "ofPumpAlert":"# di allarmi dal microinfusore",
  "ofMeal":"# di pasti",
  "totalExerTime":"Tempo totale di allenamento",
  "exerNum":"# di esercizi",
  "avgInten":"Intensità media",
  "target1":"Obiettivo",
  "high1":"Alta",
  "low1":"Basso",
  "BG Reading":"Letture GS",

  "dayByday":"Panoramica giornaliera",
  "dayBydayRe":"Report panoramica giornaliera",
  "period":"Periodo",

  "sensorOverlay":"Grafico di comparazione dati del sensore",
  "set":"Imposta",
  "setPeriod":"Imposta periodo",
  "Weekdays":"Giorni feriali",
  "Weekends":"Fine settimana",
  "Mon":"Lun",
  "Tue":"Mar",
  "Wed":"Mer",
  "Thur":"Gio",
  "Thu":"Gio",
  "Fri":"Ven",
  "Sat":"Sab",
  "Sun":"Dom",
  "Average":"Media",
  "sensorOlRe":"Raport di comparazione dati del sensore",
  "Avg":"Media",
  "±SD":"±SD",
  "ofhypo":"# di Ipo",
  "Everyday":"ogni giorno",

  "TrendAna":"Analisi dell'andamento",
  "TrendRe":"Report di analisi degli andamenti",
  "sensorGlu":"Glucosio sensore ",
  "ofBGtest":"# di test GS",
  "Basics":"Statistiche di base",
  "static":"Statistiche",
  "Med":"Mediana",
  "med":"Mediana",
  "Q1":"Q1",
  "Q3":"Q3",
  "Q11":"Q1",
  "Q31":"Q3",
  "IQR":"IQR",
  "SD":"SD",
  "CV":"CV",
  "SE1":"ES Medio",
  "distri":"di distribuzione",
  "stab":"Stabilità",
  "#high":"# di alti",
  "#low":"# di bassi",
  "aucBelow":"AUC sotto il limite",
  "aucAbove":"AUC sopra il limite",
  "bgRead":"Letture GS",
  "total":"Totale",
  "ofBolus":"# di boli",
  "avgBolus":"Bolo medio",
  "Dura1":"Durata (min)",
  "Avg/Total":"Media/Totale",
  "high":"Alto",
  "low":"Basso",
  "#hypo":"# di Ipo",
  "ofExer":"# di esercizi",

  "logbook":"Diario",
  "dailyTotal":"Totale giornaliero",
  "High Glucose":"Glucosio alto",
  "Low Glucose":"Glucosio basso",
  "No Active Patch":"Nessuna patch attiva",
  "Missed Meal":"Pasto mancato",
  "Multiple BG Readings":"Letture multiple di GS",
  "Stop Patch":"Fermo Patch",
  "Others":"Altri",
  "Other Events":"Altri eventi",
  "logRe":"Report diario",

  "DeviceSetting":"Impostazioni del dispositivo",
  "Insulin Pump":"Microinfusore",
  "MaxBasalRate":"Tasso basale massimo",
  "BasalPatterns":"Modelli basali",
  "Selected Basal Pattern":"Modello basale selezionato",
  "Maximum Bolus":"Bolo massimo",
  "Combo/Extended Bolus":"Bolo combinato/esteso",
  "BG Reminder":"Promemoria GS",
  "Bolus Increment":"Incremento del bolo",
  "Bolus Calculator":"Calcolatore di bolo",
  "Active Insulin Time":"Periodo di insulina attiva",
  "IC Ratios":"Rapporti IC",
  "Insulin Sensitivity":"Sensibilità insulinica",
  "BG Target":"Obiettivo GS",
  "Bolus Reminder":"Promemoria bolo",
  "CGM":"CGM",
  "CGM System":"Sistema CGM",
  "Glucose Unit":"Unità di glucosio",
  "Glucose Limits":"Limiti di glucosio",
  "Predicitive Alerts":"Avvisi predittivi",
  "Rate Alerts":"Avvisi di tasso",
  "type":"Tipo",
  "time":"Ora",
  "data":"Data",
  "Rate":"Rate",
  "Calibration Reminder":"Promemoria di calibrazione",
  "Calibration Repeat":"Ripetizione avviso di calibrazione",
  "Snooze":"Ripetizione",
  "Audio Options":"Opzioni audio",
  "Confidence Reminder":"Promemoria di conferma",
  "Backlight":"Retroilluminazione",
  "Sec":"sec.",
  "Alarm Clock":"Sveglia",
  "Patch Expiration":"Scadenza della patch",
  "Sensor Expiration":"Scadenza del sensore",
  "Hourly Max":"Max orario",
  "Daily Max":"Max giornaliero",
  "Low Reservoir":"Serbatoio basso",
  "Low Suspend":"Sospensione bassa",
  "Predictive Low Suspend":"Sospensione su basso previsto",
  "Rise":"Salita",
  "Fall":"Discesa",
  "Auto Off":"Spegnimento automatico",
  "Standard":"Standard",
  "Exercise":"Esercizio",
  "Holiday":"Vacanza",
  "ProgramA":"Modello A",
  "ProgramB":"Modello B",
  "--":"--",
  "Insulin":"Insulinica",

  "SUSA":"Spegnimento automatico",
  "SUSHM":"Superata somministrazione massima di 1 ora",
  "SUSDM":"Superata il dose massima giornaliera",
  "SUSLSG":"Sospensione su basso",
  "SUSPLSG":"Sospensione su basso previsto",
  "Pump Restarted":"Microinfusore riavviato",
  "Meter BG Now":"Misura GS adesso",
  "Sensor Exp in 2 Hours":"Scad. sensore in 2 ore",
  "Sensor Exp in 6 Hours":"Scad. sensore in 6 ore",
  "Sensor Exp in 30 Min":"Scad. sensore in 30 min",
  "Sensor Calibration Error":"Errore calibrazione sensore",
  "Sensor Error":"Nessuna lettura",

  "Device Settings Report":"Report impostazioni dispositivo",
  "24h Total":"24 ore totali",
  "Device Settings at":"Impostazioni dispositivo al",
  "Start":"Inizio",
  "Combo/Ext Bolus":"Bolo combinato/est.",
  "Time Format":"Formato orario",
  "Device Options（CGM System)":"Opzioni del dispositivo (sistema CGM)",
  "Device Options（Insulin Pump)":"Opzioni del dispositivo (microinfusore)",
  "Dispay Settings (Screen)":"Impostazioni Dispay (schermo)",
  "Dispay Settings (Backlight)":"Impostazioni Dispay (retroilluminazione)",
  "Graph Range":"Grafici andamento glucosio",
  "Range":"Range",
  "Repeat":"Ripetizione",
  "Glucose Alerts":"Avvisi glucosio",
  "Alert Silence":"Silenziamento avvisi",

  "Create":"Crea",
  "Event Filter":"Filtro eventi",
  "HbA1c1":"HbA1c",
  "Urine Ketone":"Chetone nelle urine",
  "Injection":"Iniezione",
  "Other":"Altro",
  "Event Type":"Tipo di evento",
  "Details":"Dettagli",
  "Notes":"Note",
  "Source":"Sorgente",
  "edit":"Modifica",
  "Action":"Azioni",
  "EventReport":"Report di riepilogo degli eventi",
  "By Date":"Per data",
  "By Category":"Per categoria",
  "Event Summary":"Riepilogo degli eventi",
  "No data":"Nessun dato",
  "No1":"Nessun",
  "data1":"dato",
  "#":"#",
  "BG Summary":"Riepilogo GS",
  "Carbs Summary":"Riepilogo dei carboidrati",
  "Injection Summary":"Riepilogo delle iniezioni",
  "Exercise Summary":"Riepilogo esercizi",
  "Input Notes":"Inserisci una nota",

  "Profile":"Profilo",
  "Complications":"Complicazioni",
  "Concomitant diseases":"Malattie concomitanti",
  "Suggestion":"Suggerimenti",
  "Coronary heart disease":"Malattia coronarica",
  "High blood lipids":"Lipidi nel sangue alti",
  "High blood pressure":"Alta pressione sanguigna",
  "Kidney disease":"Malattie renali",
  "Neuropathy":"Neuropatia",
  "Obesity":"Obesità",
  "Peripheral arterial disease":"Malattia arteriosa periferica",
  "Retinopathy":"Retinopatia",
  "Smoking addiction":"Dipendenza da fumo",
  "Enter date":"Inserisci la data",
  "Enter suggestion":"Inserisci il suggerimento",
  "Enter Notes":"Enter Notes",
  "Select":"Seleziona",
  "Prescription":"Prescrizione",
  "Medicine":"Medicinale",
  "Dose":"Dose",
  "Enter medicine":"Inserire il medicinale",
  "Enter dose":"Inserire la dose",
  "Enterdis":"Inserisci il malattie concomitanti",
  "Add note":"Aggiungi una nota",
  "Add Content":"La lunghezza massima è di 1000 caratteri.",
  "Other suggestions":"Altri suggerimenti",
  "OK":"OK",
  "HCP":"HCP",
  "Content":"Contenuto",
  "Records Report":"Report delle registrazioni",

  "Quick Print":"Stampa rapida",
  "Quick Print Settings":"Impostazioni di stampa rapida",
  "Select duration":"Seleziona la durata",
  "One Week":"Una settimana",
  "One Month":"Un mese",
  "One Quarter":"Tre mesi",
  "End date":"Data di fine",
  "Yesterday":"Ieri",
  "Last Sunday":"Domenica scorsa",
  "Last Saturday":"Sabato scorso",
  "Last Day of Last Month":"Last Day of Last Month",
  "Last Day of Last Quarter":"Last Day of Last Quarter",
  "Customized":"Imposta",
  "Week Filter":"Filtra settimana",
  "Select reports to print":"Seleziona i report da stampare",
  "Daily Summary":"Riepilogo giornaliero",
  "Day By Day Overview":"Panoramica giorno per giorno",
  "Sensor Overlay":"Comparazione dati sensore",
  "Trend Analysis":"Analisi dell'andamento",
  "Logbook":"Diario",
  "Device Settings Review":"Report delle impostazioni del dispositivo",
  "createReport":"Crea report",

  "Segment Analysis":"Analisi del periodo",
  "Sensor Glucose Profile":"Profilo del glucosio del sensore",
  "# of Boluses":"N. di boli",
  "Bolus Insulin":"Insulina Bolo",
  "Basal Pattern":"Modello basale ",
  "Segment Analysis Report":"Report di analisi del segmento",
  "Avg Glucose":"Glucosio medio",
  "Below":"Sotto",
  "In Target Range":"Nel range obiettivo",
  "Coefficient of variation":"Coefficiente di variazione",
  "% Time CGM Active":"% Tempo CGM attivo",
  "est_a1c_t1":"A1C stimato: ",
  "est_a1c_t2":"calcolato dai valori di SG",
  "est_a1c_t3":"Nota: l'A1C stimato non sostituisce la misurazione di laboratorio",

  "acceptTip":" ti ha permesso di visualizzare in remoto le sue informazioni di salute.",
  "cancelTip":" ha negato l'autorizzazione a visualizzare da remoto le sue informazioni di salute. Puoi fare una nuova richiesta se necessario.",
  "rejectTip":" ha negato la tua richiesta di visualizzazione remota.",
  "Read":"Leggi",

  "Connection":"Contatto",
  "connections1":"Elenco contatti",
  "Add Connection":"Aggiungi contatto",
  "SG":"SG",
  "Active Insulin":"Insulina attiva",
  "Stop following":"Smetti di seguire",
  "Enter username (email)":"Inserisci il nome utente (email)",
  "Search results":"Risultati di ricerca",
  "Send request":"Invia richiesta",
  "View graphs":"Visualizza grafici",
  "Agree":"Approva",
  "Deny":"Nega",
  "Remove":"Rimuovi",
  "Cancel Requset":"Annulla richiesta",
  "Remark":"Commento",

  "Warm up":"Riscaldamento",
  "Monitoring":"Monitoraggio in corso",
  "Transmitter Error":"Errore del trasmettitore",
  "Sensor Failure":"Sensore guasto",
  "Sensor Expired":"Sensore scaduto",
  "Lost Sensor":"Sensore perso",
  "Not Calibrated":"Non calibrato",
  "Calibrating":"Calibrazione in corso",
  "Calibration Needed":"Calibrazione necessaria",
  "Calibration Error":"Errore di calibrazione",
  "Charging Battery":"Caricamento della batteria in corso",
  "Battery Charged":"Batteria carica",

  "To be filled":"In attesa di riempimento",
  "Filled with insulin":"Riempito con insulina",
  "Priming":"Innesco in corso",
  "Priming completed":"Innesco completato",
  "Inserting needle":"Inserimento dell'ago in corso",
  "Patch activated":"Patch attivata",
  "Delivering Basal":"Somministrazione basale in corso",
  "Exceeds Max 1 Hour Delivery":"Superata somministrazione massima di 1 ora",
  "Exceeds Max TDD":"Superata il dose massima giornaliera",
  "Suspend":"Sospeso",
  "Occlusion Detected":"Occlusione rilevata",
  "Patch Expired":"Patch scaduta",
  "Empty Reservoir":"Serbatoio vuoto",
  "Patch Error":"Errore patch",
  "Pump Base Error":"Errore base microinfusore",
  "Patch Battery Depleted":"Batteria patch esaurita",
  "Magnetic sensor not calibrated":"Sensore magnetico non calibrato",

  "Patient Profile":"Profilo del paziente",

  "On":"Acceso",
  "on":"Acceso",
  "Off":"Spento",
  "off":"Spento",

  "CORONARY_HEART_DISEASE":"Malattia coronarica",
  "HIGH_BLOOD_LIPIDS":"Lipidi nel sangue alti",
  "HIGH_BLOOD_PRESSURE":"Alta pressione sanguigna",
  "KIDNEY_DISEASE":"Malattie renali",
  "NEUROPATHY":"Neuropatia",
  "OBESITY":"Obesità",
  "PERIPHERAL_ARTERIAL_DISEASE":"Malattia arteriosa periferica",
  "RETINOPATHY":"Retinopatia",
  "SMOKING_ADDICTION":"Dipendenza da fumo",

  "saveTip":"Salvato con successo.",
  "changePaTip":"La password è stata modificata.",
  "enterEmTip":"Inserisci il tuo indirizzo email.",
  "verErrTip":"Codice di verifica errato.",
  "chooseEventTip":"Scegli gli eventi da stampare",
  "chooseDataTip":"Seleziona i dati da stampare",
  "dateWrongTip":"La data di fine non può essere precedente alla data di inizio.",
  "infoWrongTip":"Si prega di compilare tutti i campi obbligatori.",
  "createdSuccssTip":"Creato con successo",
  "selectData":"Seleziona i dati da salvare",

  "acceSu":"Richiesta di connessione accettata",
  "acceEr":"Aggiunta del nuovo collegamento fallita",
  "rejeSu":"Richiesta di collegamento respinta",
  "rejeEr":"Rifiuto della richiesta fallito",

  "userNotExist":"Il nome utente non esiste.",
  "Password incorrect":"Password scorretta.",
  "UserType incorrect":"Tipo di utente errato",

  "registSuccess":"Il tuo account è stato creato con successo.",
  "registFailed":"Impossibile registrare un nuovo account.",
  "sentSuccess":"Messaggio inviato con successo",
  "sentFailed":"Impossibile inviare il messaggio",
  "Input error":"Errore di inserimento dati",

  "deletePtip":"Sei sicuro di voler eliminare questi pazienti?",
  "deleteEvents":"Sei sicuro di voler cancellare questi eventi?",
  "deleteData":"Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis":"Sei sicuro di voler cancellare?",
  "confirm":"Conferma",
  "deleteSuccess":"Cancellato con successo",
  "deleteFailed":"Impossibile eliminare l'elemento",
  "modifySuccess":"Modificato con successo",
  "modifyFailed":"Impossibile effettuare la modifica",
  "createSuccess":"Creato con successo",
  "createFailed":"Creazione fallita",
  "editSuccess":"Modifica eseguita",
  "editFailed":"Modifica fallita",
  "Time overlapped":"Le sessioni selezionate sono sovrapposte",
  "showAlert":"Mostra avvisi",

  "dashboard":"Riepilogo",
  "dboard_glucose_statistics":"Statistiche",
  "dboard_glucose":"Glucosio",
  "dboard_cgm":"CGM",
  "dboard_insulin":"Insulina",
  "dboard_carbs":"Carboidrati",
  "dboard_exercise":"Esercizio",
  "dboard_glucose_avg":"Media",
  "dboard_cgm_avg":"Media",
  "dboard_insulin_avg":"Dose giornaliera media",
  "dboard_carbs_avg":"Carboidrati medi/giorno",
  "dboard_exercise_avg":"Tempo medio/giorno",
  "dboard_sd":"DS",
  "dboard_num":"#",
  "dboard_num_days":"# days",
  "dboard_statistics":"Statistiche",
  "dboard_BG":"GS",
  "dboard_BG_calibration":"GS/Calibrazione (al giorno)",
  "dboard_SG":"SG",
  "dboard_AUC_high":"AUC alto >",
  "dboard_AUC_low":"AUC basso <",
  "dboard_highest_value":"Valore più alto ",
  "dboard_lowest_value":"Valore più basso",

  "dboard_pump":"Microinfusore",
  "dboard_avg_daily_dose":"Dose giornaliera media",
  "dboard_SD":"DS",
  "dboard_daily_basal":"Basale giornaliera",
  "dboard_daily_bolus":"Bolo giornaliero",
  "dboard_avg_bolus_num":"No. medio boli al giorno",
  "dboard_avg_suspend_time":"Tempo medio di sospensione",
  "dboard_avg_reservoir_usage":"Utilizzo medio del serbatoio",
  "dboard_days":"days",

  "dboard_manual_bolus":"Bolo manuale (volume/no. al giorno)",
  "dboard_normal":"-Normale",
  "dboard_extend":"-Esteso",
  "dboard_combo":"-Combinato",

  "dboard_bolus_calculator":"Calculatore Bolo (Volume/no. al giorno)",
  "dboard_food_bolus":"-Calc. bolo pasto",
  "dboard_corr_bolus":"-Calc. bolo correz.",
  "dboard_override_add":"-Bypassa (+)",
  "dboard_override_sub":"-Bypassa (-)",

  "dboard_report":"Riepilogo report",

  "stopFollow":"Sei sicuro di voler smettere di seguire questo paziente?",
  "CancelTip1":"Sei sicuro di voler eliminare questo collegamento?",

  "Warning":"Attenzione",
  "agreeConnect":"Se si fa clic su ''Accetto'' per accettare la richiesta di collegamento, i propri dati di salute saranno resi disponibili al nuovo contatto.",
  "denyConnect":"Sei sicuro di voler rifiutare la richiesta di contatto?",
  "deleteConnect":"Sei sicuro di voler eliminare questo collegamento? Se lo elimini, il contatto non sarà più in grado di visualizzare i tuoi dati di salute.",

  "Choose the events to print":"Scegli gli eventi da stampare",
  "tryAgain":"Riprova",
  "username and password is required":"username and password is required",
  "A name is required":"È richiesto un nome.",
  "username is required":"È richiesto il nome utente.",
  "The date choose wrong":"Scelta data errata",
  "Date no more than 14 days":"Non è possibile selezionare più di 14 giorni.",

  "CancelTip":"Sei sicuro di voler eliminare il collegamento?",
  "removeConnect":"Cancellato con successo",

  "dateErr1":"Non è possibile selezionare più di 90 giorni.",
  "dateErr2":"La data di fine non può essere precedente alla data di inizio.",

  "Not Filled":"Imprecisato",
  "Today":"Oggi",
  "duration":"Durata",
  "interval":"Interval",
  "7 days":"7 giorni",
  "14 days":"14 giorni",
  "30 days":"30 giorni",
  "90 days":"90 giorni",
  "g":"g",

  "Sound+Vibrate":"Audio + Vibrazione",
  "Sound":"Audio",
  "Vibrate":"Vibrazione",
  "Silent":"Non disturbare",
  "1":"Una volta",
  "2":"Giornaliero",
  "noMes":"Non ci sono messaggi.",
  "noConnect":"Non ci sono connessioni.",
  "Customize":"Imposta",
  "GB":"United Kingdom",
  "CN":"China",
  "FR":"France",
  "DD":"Germany",
  "DE":"Germany",
  "SE":"Sweden",
  "AU":"Australia",
  "HKF":"Hongkong",
  "HU":"Hungary",
  "IT":"Italy",
  "NL":"Netherlands",
  "Nor":"Norway",
  "PT":"Portugal",
  "ES":"Spain",
  "TR":"Turkey",

  "Jan":"Gen",
  "Feb":"Feb",
  "Mar":"Mar",
  "Apr":"Apr",
  "May":"Mag",
  "Jun":"Giu",
  "Jul":"Lug",
  "Aug":"Ago",
  "Sep":"Set",
  "Oct":"Ott",
  "Nov":"Nov",
  "Dec":"Dic",
  "ApplyTip":" Richiesta per visualizzare i tuoi dati.",
  "noReadings":"Nessuna lettura",

  "daop_A6_system":"A6 Touchcare System",
  "daop_easytouch_easyview":"EasyTouch / EasyView iPad",
  "daop_TY012_TY015":"TY012/TY015",
  "daop_easysense":"EasySense",
  "daop_delete_data":"Delete Data",
  "daop_uploaded_data":"Dati caricati",
  "daop_uploaded_data_text":"I dati provengono dall'app EasyTouch o dall'app EasyView per iPad.",
  "daop_realtime_data":"Dati in tempo reale",
  "daop_realtime_data_text":"The data is from EasySense App or EasyPatch App.",

  "ins_unit":"(U)",
  "ins_unit2":"U",
  "basal_unit":"(U/H)",
  "basal_unit2":"U/H",

  // 告警
  "Alerts_Patch_Battery_Low":"Batteria patch bassa",
  "Alerts_Patch_Battery_Depleted":"Batteria patch esaurita", // update
  "Alerts_Lost_Pump":"Lost Pump",
  "Alerts_Low_Reservoir":"Serbatoio basso", // update
  "Alerts_Empty_Reservoir":"Serbatoio vuoto",
  "Alerts_Patch_Expiration_Advisory":"Avviso di scadenza patch",
  "Alerts_Patch_Exp_In_1_Hour":"Patch Exp In 1 Hour",
  "Alerts_Patch_Expired":"Patch scaduta", // update
  "Alerts_Patch_Error":"Errore patch",
  "Alerts_Pump_Base_Error":"Errore base microinfusore",
  "Alerts_Basal_Rate_Key_Error":"Basal Rate Key Error",
  "Alerts_Occlusion_Detected":"Occlusione rilevata", // update
  "Alerts_End_Of_Suspend":"End Of Suspend",
  "Alerts_Exceeds_Max_TDD":"Superato max totale giornaliero", // update
  //"Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery":"Superata somministr. max per 1h",
  //"Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  "Alerts_Predictive_Low_Suspend":"Sospensione su basso previsto", // update
  "Alerts_Low_Suspend":"Sospensione bassa",
  "Alerts_Auto_Off":"Spegnimento automatico", // update

  "Alerts_Pump_Restart":"Pump Restart",  // 22
  "Alerts_Auto_Off_Warning":"Auto Off Warning",  // 23
  "Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //24
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  // 25
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //33

  "Alerts_Lost_Sensor":"Sensore perso", // update
  "Alerts_Transmitter_Battery_Low":"Batteria del trasmettitore scarica",
  "Alerts_Charge_Transmitter":"Carica il trasmettitore",
  "Alerts_Sensor_Error":"Nessuna lettura",
  "Alerts_Transmitter_Error":"Errore del trasmettitore",
  "Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  //"Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  "Alerts_Sensor_Failure":"Sensore guasto",
  "Alerts_Sensor_Calibration_Reminder":"Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now":"Misura GS adesso",
  "Alerts_Sensor_Exp_in_6_Hours":"Scad. sensore in 6 ore",
  "Alerts_Sensor_Exp_in_2_Hours":"Scad. sensore in 2 ore", // update
  "Alerts_Sensor_Exp_in_30_Min":"Scad. sensore in 30 min",
  "Alerts_Sensor_Expired":"Sensore scaduto", // update
  "Alerts_Rapid_Rise":"Salita rapida",
  "Alerts_Rapid_Fall":"Discesa rapida",
  "Alerts_High_Predicted":"Alto previsto",
  "Alerts_Low_Predicted":"Basso previsto",
  "Alerts_High_Glucose":"Glucosio alto", // update
  "Alerts_Low_Glucose":"Glucosio basso", // update
  "Alerts_Below_3.1_mmol/L":"Sotto 3,1 mmol/L",
  "Alerts_Transmitter_Battery_Low_2":"Batteria del trasmettitore scarica",

  "Alerts_PDM_Battery_Low":"Batteria PDM bassa",
  "Alerts_Replace_Battery":"Carica il PDM adesso",

  // Alert页面
  "Alert":"Alert",
  "Alerts":"Avvisi",
  "Alert Filter":"Alert Filter",
  "PDM":"PDM",
  "Pump":"Microinfusore",
  //"CGM":"CGM",

  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode":"Tempo in modalità auto",
  "t1221_Average_SG_SD":"Media SG± SD",
  "t1221_Time_in_Target_Range":"Tempo nel target",
  "t1221_Time_above_Range":"Tempo sopra il range",
  "t1221_Time_below_Range":"Tempo sotto il range",
  "t1221_Auto_Basal_per_day":"Basale automatica (al giorno)",
  "t1221_Auto_Bolus_per_day":"Bolo automatico (al giorno)",
  "t1221_Auto_Mode_Exits":"Uscita modalità automatica",
  "t1221_No_Sensor_readings":"nessuna lettura del sensore",
  "t1221_Max_Delivery":"Erogazione massima",
  "t1221_Min_Delivery":"Erogazione minima",
  "t1222_autoModeBasal":"Basale modalità auto",
  "t1222_autoModeCorrBolus":"Correzione del bolo modalità auto",
  "t1222_autoSnack":"Auto Merenda",
  "t1222_autoBreakfast":"Auto Colazione",
  "t1222_autoLunch":"Auto pranzo",
  "t1222_autoDinner":"Auto Cena",
  "t1222_autoExercise":"Auto esercizio",
  "t1222_Snack":"Merenda",
  "t1222_Auto_Mode":"Modalità auto",
  "t1222_Time_in_Auto_Mode":"Tempo in modalità auto(%)",
  "t1222_Avg_SD":"Avg(mg/dL)±SD",
  "t1222_Target_Range":"Range target(%)",
  "t1222_Above_Range":"Sopra il range(%)",
  "t1222_Below_Range":"Sotto il range(%)",
  "t1222_Auto_Mode_Exits":"# uscita di modalità auto",
  "t1221_Auto_Mode":"Modalità auto",
  "t1222_auto_basal":"Basale auto",
  "t1222_auto_bolus":"Bolo auto",
  "t0805_User_Management":"Gestione utenti",
  "t0805_Patient_Management":"Gestione del paziente",
  "t0805_Operation_History":"Cronologia delle operazioni",
  "t0805_User_List":"lista degli utenti",
  "t0805_User":"Utente",
  "t0805_Time":"Volta",
  "t0805_Operation_Type":"Tipo di operazione",
  "t0805_Back":"Indietro",
  "t0805_Add":"Aggiungi",
  "t0805_Delete":"Elimina",
  "t0809_Add_User":"Aggiungi utente",
  "t1028_Pattern_C":"Modello C",
  "t1028_Pattern_D":"Modello D",
  "t1029_Auto_meal_bolus":"Auto meal bolus",
  "t1029_Auto_mode_correction_bolus":"Auto mode correction bolus",
  "t1029_Sick":"Malato",
  "t1029_Auto_Mode_Feature":"Modi auto feator",
  "t1029_Target_SG":"Obbiettivo SG",
  "t1029_Auto_Meal_Handling":"Gestione Auto. Pasto",
  "t1029_Total_Daily_Dose":"Dose Giornaliera Totale",
  "t1029_Pump_Light":"Luce pompa.",
  "t1029_Alerts_for_Hypo":"Avvisi per Ipo",
  "t1102_Out_of_Range":"Fuori dal range",
  "t1102_Command_Reminder":"Promemoria comando",
  "t1102_Alarms_Alerts_on_APP":"Avvisi e allarmi pompa",
  "t1102_Alarms_on_App":"Allarmi App",
  "t1102_Alerts_on_App":"Aviisi App",
  "t1102_Factory_Calibration":"Fattore di calibrazione",
  "t1102_Alerts_for_Low":"Avvisi per basso",
  "t1102_Alerts_for_High":"Avvisi per alto",
  "t1102_Alerts_for_Others":"Altri avvisi",
  "t1102_Adjustment":"Regolazione",
  "t1102_Suggested":"Suggerito",
  "t1103_Glucose":"Glucosio",
  "t1103_CGM":"CGM",
  "t1103_Insulin":"Insulina",
  "t1103_Carbs":"Carboidrati",
  "t1103_Exercise":"Esercizio",
  "t1103_Min_Max":"Min/Max",
  "t1103_Target_Range":"Obiettivo ",
  "t1103_Overall_Tine_In_Range":"Panoramica: Time in range",
  "t1103_Basal":"Basale",
  "t1103_Bolus":"Bolo",
  "t1103_Basal_Bolus":"Basale e boli",
  "t1103_Auto_Mode_Time_In_Range":"Modalità automatica: Time in range",
  "t1103_Time_below_range":"Tempo sotto il range",
  "t1103_Time_above_range":"Tempo sopra il range",
  "t1103_Time_in_target_range":"Tempo nel range",
  "t1103_Incorrect_Password":"Password errata, $1 tentativo rimasto, inserire la password corretta.",
  "t1103_Incorrect_locked":"I tentativi falliti superano il limite, l'account è stato bloccato. Riprova tra $1 minuti.",
  "t1104_The_data_is_from":"I dati provengono dall'app EasySense o dall'app EasyPatch.",
  "t1104_Privacy_Policy":"Privacy policy e Termini d'uso",
  "t1104_updated_privacy_policy":"Abbiamo aggiornato la policy sulla privacy e i termini d'uso. Per favore leggere attentamente e acconsentire ai nuovi termini prima di utilizzare EasyPatch.",
  "t1104_Disagree":"Non acconsento",
  "t1104_Agree":"Acconsenti",
  "t1105_Upload_History":"Carica cronologia",
  "t1105_Delete_Data":"Elimina dati",
  "t1105_Target_Range":"Obiettivo ",
  "t1105_request_to_view_your_data":"$1 richiesta per visualizzare i tuoi dati.",
  "t1105_Recent_Updates":"Aggiornamenti recenti",
  "t1108_No_data":"Nessun dato",
  "t1108_Pump_Bash_SN":"SN base del microinfusore",
  "t1108_Transmitter_SN":"SN trasmettitore",
  "t1112_Normal_Glucose":"Glucosio Normale",
  "t1112_Manual_Bolus_or_Modified_Bolus":"Bolus manuale o bolus modificato",
  "t1112_Auto_Mode_Started":"Modalità auto avviata",
  "t1112_Auto_Mode_Exit":"Uscita dalla modalità auto",
  "t1112_Normal_Bolus":"Bolo normale",
  "t1112_Extended_Bolus":"Bolo esteso",
  "t1112_Combo_Bolus":"Bolo combinato",
  "t1112_Carbs":"Carboidrati",
  "t1112_Glucose":"Glucosio",
  "t1112_BG":"GS",
  "t1112_Audio":"Audio",
  "t1112_Tone":"Toni",
  "t1112_Audio_Options":"Opzioni audio",
  "t1112_Weight_Unit":"Unità Di Peso",
  "t1112_Height_Unit":"Unità Di Altezza",
  "t1112_Not_available":"Non Disponibile",
  "t1112_Number":"Numero",
  "t1112_days":"# giorni",
  "t1112_min":"min",
  "t1113_days":"giorni",
  "t1215_Security":"Sicurezza",
  "t1215_MFA":"Autenticazione a più fattori (MFA)",
  "t1215_Enter_verification_code":"Inserisci il codice di verifica",
  "t1215_Multi_factor_ON":"L'autenticazione a più fattori è ATTIVA. Il codice di verifica è stato inviato a $1 Invia il codice di verifica.",
  "t1215_Verification_code_incorrect":"Codice di verifica non corretto",
  "t1215_Show_Glucose_Value":"Mostra il valore del glucosio",
  "t1221_enter_verification_code":"Inserisci il codice di verifica a 6 cifre inviato a $1.",
  "t1221_Verification_Success":"Verificato con successo",
  "t1222_We_will_only_process":"Con il tuo consenso elaboreremo i tuoi dati sanitari solo tramite l'app/sito web di Medtrum. ",
  "t1222_If_you_are_under_years":"Se si ha meno di 16 anni, è necessario il consenso del genitore o del tutore legale per registrarsi in questa app.",
  "t1221_register_cn":"Hai il diritto di non caricare i dati del dispositivo sull'app, nel qual caso i dati non saranno accessibili ad altri. Se si sceglie di non registrarsi nell'app/sito Web di Medtrum, i dati sanitari rimarranno solamente sul dispositivo stesso. ",
  "t1221_register_eu":"Se si sceglie di registrare il proprio account Medtrum e accedere alla nostra app utilizzando l'account, i dati sanitari registrati sull'app verranno caricati sul nostro server in Europa e saranno conservati per 2 anni. Hai il diritto di non caricare i dati del dispositivo sull'app, nel qual caso i dati non saranno accessibili ad altri. Se si sceglie di non registrarsi nell'app/sito Web di Medtrum, i tuoi dati sanitari saranno conservati solamente sul dispositivo stesso.",
  "t1221_register_follow":"Elaboreremo i tuoi dati sanitari tramite l'app/sito web di Medtrum solo con il tuo consenso.",
  "t1222_Terms_of_Use":"le condizioni d'uso di Medtrum",
  "t1222_Privacy_Policy":"l'informativa sulla privacy di Medtrum",
  "t1222_Create_Account":"Crea un account",
  "t1222_Back":"Indietro",
  "t1222_Verify_your_account":"Verifica il tuo account",
  "t1222_please_check_your_account":"Invieremo un codice di verifica a $1, controlla il tuo account.",
  "t1222_I_Agree_to":"Accetto $1",
  "t1223_Invalid_Verification_Code":"Codice di verifica non valido. Per favore riprova.",
}

//export default {itMessages}



// WEBPACK FOOTER //
// ./src/lang/it.js